import axios from "axios";
export default {
    saveProject: (project) => axios.post("/Projects/SaveProject", project),
    getProject: (projectId) => axios.post("/Projects/GetProject", { Id: projectId })
};
